<section class="operations-shell">
    <header class="operations-shell__header">
        <div>
            <h1 class="operations-shell__title">Vision Operations</h1>
            <p class="operations-shell__subtitle">
                KYRA platform diagnostics for support engineers — vehicle transactions and provider events.
            </p>
        </div>
        <div class="operations-shell__status" *ngIf="visionConfig.snapshot as context">
            <span class="operations-shell__badge"
                  [class.operations-shell__badge--active]="visionConfig.isVisionActive">
                Vision {{ visionModeLabel(visionConfig.visionPolicy.vision_mode) }}
            </span>
            <span class="operations-shell__badge operations-shell__badge--muted"
                  *ngIf="context.vte_pipeline_enabled === false">
                Pipeline disabled
            </span>
        </div>
    </header>

    <nav class="operations-shell__nav" aria-label="Operations sections">
        <a *ngFor="let item of navItems"
           class="operations-shell__nav-link"
           [routerLink]="item.path"
           routerLinkActive="operations-shell__nav-link--active"
           [routerLinkActiveOptions]="{ exact: item.exact }">
            {{ item.label }}
        </a>
    </nav>

    <router-outlet></router-outlet>
</section>
